import { render } from "./RankList.vue?vue&type=template&id=2755530e&scoped=true"
import script from "./RankList.vue?vue&type=script&lang=js"
export * from "./RankList.vue?vue&type=script&lang=js"

import "./RankList.vue?vue&type=style&index=0&id=2755530e&lang=scss&scoped=true"

import exportComponent from "/Users/zsrb/Documents/中山日报/2025/zsrb-news-detail/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2755530e"]])

export default __exports__